import { render, staticRenderFns } from "./OrganizationDetailsCard.vue?vue&type=template&id=5264d406&scoped=true"
import script from "./OrganizationDetailsCard.vue?vue&type=script&lang=js"
export * from "./OrganizationDetailsCard.vue?vue&type=script&lang=js"
import style0 from "./OrganizationDetailsCard.vue?vue&type=style&index=0&id=5264d406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5264d406",
  null
  
)

export default component.exports